import type { CSSProperties } from 'react';
import './Icon.css';

export function Icon({
  name,
  size = 18,
  color = 'var(--t3, #9CA3B8)',
  style = {},
}: {
  name: string;
  size?: number;
  color?: string;
  style?: CSSProperties;
}) {
  return (
    <span className="material-symbols-rounded display-icon" style={{ fontSize: size, color, ...style }}>
      {name}
    </span>
  );
}
